export default __webpack_public_path__ + "static/img/matteo_ward.f6f0ce0.jpg";